import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/components/feature/PostCard";
import { allPosts } from "@/lib/content";

export default function RecommendGrid() {
  const picks = [allPosts[3], allPosts[6], allPosts[9]].filter(Boolean);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="TODAY'S PICKS"
          title="今日推荐"
          description="从三个栏目里各挑一篇，节奏轻、篇幅短，五分钟以内就能读完。"
          actionLabel="更多推荐"
          actionTo="/category/lezi"
        />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {picks.map((post) => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
}